export default "__VITE_ASSET__C5N8w9bb__"